<template>
  <!-- Header -->
  <header class="header">
    <div v-if="!ShowBack"></div>

    <!-- Icon back -->
    <button
      v-if="ShowBack"
      type="button"
      class="header__back"
      aria-label="Back"
      @click="back"
    >
      <img src="../assets/images/event/icon-back.svg" alt="" aria-hidden="true" />
    </button>

    <!-- Page title -->
    <div class="header__title">
      {{ HeaderTitle }}
      <div v-if="HeaderSubTitle" class="header__event-name">
        {{ HeaderSubTitle }}
      </div>
    </div>

    <!-- Logout -->
    <div class="header__logout">
      <button
        v-if="ShowLogoutButton"
        type="button"
        aria-label="Log out"
        @click="this.showLogout = true"
      >
        <img
          src="../assets/images/event/icon-logout.svg"
          alt=""
          aria-hidden="true"
        />
      </button>
    </div>

    <!-- User -->
    <div class="header__user" v-if="ShowLogoutButton">
      {{ this.$store.getters.getLoggedInUser }}
    </div>

    <!-- Logout popup -->
    <Teleport to="body">
      <div v-if="showLogout" class="popup-overlay">
        <div
          class="popup"
          role="dialog"
          aria-modal="true"
          aria-labelledby="logout-dialog-title"
        >
          <!-- Popup header -->
          <div class="popup__header d-flex justify-content-between">
            <div class="popup__header-title" id="logout-dialog-title">Logout</div>
            <button
              class="popup__close"
              @click="close"
              type="button"
              aria-label="Close"
            >
              <img
                src="../assets/images/attendees/icon-close.svg"
                alt=""
                aria-hidden="true"
              />
            </button>
          </div>

          <!-- Popup body -->
          <div class="popup__body">
            <div class="popup__title mb-0">Are you sure you want to log out?</div>
          </div>

          <!-- Popup footer -->
          <div class="popup__footer">
            <button @click="close" class="btn btn--default btn--sm" type="button">
              Cancel
            </button>
            <button
              @click="logout"
              class="btn btn--primary btn--sm ms-2"
              type="button"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </header>
</template>

<script>
export default {
  name: "HeaderComponent",
  props: {
    HeaderTitle: String,
    HeaderSubTitle: String,
    ShowLogoutButton: Boolean,
    ShowBack: Boolean,
  },
  data: () => ({
    showLogout: false,
  }),
  emits: ["back"],
  methods: {
    back() {
      this.$emit("back");
    },
    logout() {
      this.$store.commit("logout");
    },
    close() {
      this.showLogout = false;
    },
  },
};
</script>
